<template>
  <div>
    <v-data-table
      :loading="loading"
      :items="items"
      :headers="headers"
      class="elevation-1"
      disable-pagination
      hide-default-footer
    >
      <template v-slot:[`item.disabled`]="{ item }">
        <v-switch
          @click="changeStatus(item)"
          dense
          :label="item.disabled ? 'غیر فعال' : 'فعال'"
          v-model="item.disabled"
          :false-value="true"
          :true-value="false"
        ></v-switch>
      </template>
      <template v-slot:[`item.operation`]="{ item }">
        <v-btn icon color="primary" @click="getMerchantDelegationById(item)" v-if="!item.approvedByAdmin"
          ><v-icon>mdi-lead-pencil</v-icon></v-btn
        >
        <v-btn icon color="error" @click="deleteMerchantDelegation(item)"
          ><v-icon>mdi-delete</v-icon></v-btn
        >
      </template>
    </v-data-table>
  </div>
</template>

<script>
import { RepoFactory } from '@/baseRepository/Factory';
const merchantDelegationsRepository = RepoFactory.get('merchantDelegations');
import Helper from '@/core/helpers';
export default {
  props: {
    categoryType: {
      type: String,
      default: null,
    },
  },
  data() {
    return {
      loading: false,
      items: [],
      headers: [
        { sortable: true, text: 'عنوان', value: 'title' },
        { sortable: true, text: 'استان ', value: 'stateName' },
        { sortable: true, text: 'شهرستان', value: 'cityName' },
        { sortable: true, text: 'وضعیت', value: 'disabled' },
        {
          text: 'عملیات',
          value: 'operation',
        },
      ],
    };
  },
  computed: {
    merchantBaseUrl() {
      return this.$store.getters.merchantBaseUrl;
    },
    merchantId() {
      return this.$store.getters.currentMerchant;
    },
  },
  created() {
    this.getMerchantDelegations();
  },

  watch: {
    merchantId() {
      this.getMerchantDelegations();
    },
    merchantBaseUrl() {
      return this.$store.getters.merchantBaseUrl;
    },
  },
  methods: {
    changeStatus(item) {
      const loader = this.$loading.show();
      if (item.disabled) {
        merchantDelegationsRepository
          .disableMerchantDelegation(item.id, this.merchantBaseUrl, {})
          .then((res) => {
            this.$dialog.message.success('با موفقیت غیرفعال شد', {
              position: 'top-left',
            });
            loader.hide();
          })
          .catch((error) => {
            Helper.handleErrors(error, this);
            loader.hide();
          });
      } else {
        merchantDelegationsRepository
          .enableMerchantDelegation(item.id, this.merchantBaseUrl, {})
          .then((res) => {
            this.$dialog.message.success('با موفقیت فعال شد', {
              position: 'top-left',
            });
            loader.hide();
          })
          .catch((error) => {
            Helper.handleErrors(error, this);
            loader.hide();
          });
      }
    },
    getMerchantDelegationById(item) {
      const loader = this.$loading.show();
      merchantDelegationsRepository
        .getMerchantDelegationById(item.id, this.merchantBaseUrl, {
          MerchantId: this.merchantId,
        })
        .then((res) => {
          this.$store.commit('setMerchantDelegationSelectedForEdit', res.data);
          this.$store.commit('setMerchantDelegationIsEdit', true);
          this.$store.commit('setMerchantDelegationFormStatus', true);
          loader.hide();
        })
        .catch((error) => {
          Helper.handleErrors(error, this);
          loader.hide();
        });
    },
    getMerchantDelegations() {
      if (this.merchantId) {
        const loader = this.$loading.show();
        this.loading = true;
        merchantDelegationsRepository
          .getMerchantDelegations(this.merchantBaseUrl, {
            MerchantId: this.merchantId,
          })
          .then((res) => {
            this.items = res.data;
            this.loading = false;
            loader.hide();
          })
          .catch((error) => {
            this.loading = false;
            loader.hide();
            Helper.handleErrors(error, this);
          });
      }
    },
    deleteMerchantDelegation(item) {
      this.$dialog.warning({
        text: `آیا از حذف  <span class="red--text">${item.title}</span> اطمینان دارید؟`,
        title: 'هشدار',
        actions: {
          false: {
            color: 'red',
            text: 'خیر',
          },
          true: {
            color: 'primary',
            text: 'بله',
            handle: () => {
              const loader = this.$loading.show();
              merchantDelegationsRepository
                .deleteMerchantDelegation(item.id, this.merchantBaseUrl, {
                  MerchantId: this.merchantId,
                })
                .then(() => {
                  this.getMerchantDelegations();
                  this.$dialog.message.success('با موفقیت حذف گردید', {
                    position: 'top-left',
                  });
                  loader.hide();
                })
                .catch((error) => {
                  Helper.handleErrors(error, this);
                  loader.hide();
                });
            },
          },
        },
      });
    },
  },
};
</script>

<style scoped></style>
